<template>
  <div class="outer">
    <div v-if="!detailMode">
      <header><h3>Add New Project</h3></header>
      <ProjectForm />
    </div>
    <div v-else style="background-color:#f1f1f1; padding:20px; box-sizing:border-box;">
      <header><h3>Project Details</h3></header>
      <div class="bigBox">
        <h3>Project Name</h3>
        <p>{{project.projectName}}</p>
      </div>
      <div class="bigBox">
        <h3>Description</h3>
        <p>{{project.description}}</p>
      </div>
      <div class="bigBox">
        <h3>Project Type</h3>
        <p><span style="margin:0px 10px; color:#fff; background:#313131; border-radius:5px; padding:8px;" v-for ="type in project.type" :key="type">{{type}}</span></p>
      </div>
      <div class="bigBox">
        <h3>Date</h3>
        <p>{{project.date}}</p>
      </div>
      <div class="bigBox">
        <h3>Project Mode</h3>
        {{project.mode}}
      </div>
    </div>
  </div>
</template>

<script>
import ProjectForm from "../components/NewProject/ProjectForm.vue";
export default {
  props:['id'],
  data(){
    return{
      detailMode:true,
    }
  },
  components: {
    ProjectForm,
  },
  created(){
    if(this.id === undefined){
      this.detailMode = false;
    }
  },
  computed: {
    project() {
      return this.$store.getters["projects/getAllProjects"].find(x => x.projectId === this.id);
    },
  }
};
</script>

<style scoped>
.outer {
  width: 98%;
  border: 1px solid #c1c1c1;
  margin: 1%;
}
header {
  padding: 0px 10px;
  background: slateblue;
  color: #fff;
  float: left;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 25px;
}
</style>
